export class CreatUpdateLead {
    wsCallDetailsData: WSCallDetailsData;
}

export class WSCallDetailsData {
    WSCallUserFirstName: string;
    WSCallUserMiddleName: string;
    WSCallUserLastName: string;
    WSCallExistingCardHolder: string;
    WSCallUserCardNumber: string;
    WSCallUserGender: string;
    WSCallUserCity: string;
    WSCallUserOccupationCode: string;
    WSCallUserDOB: string;
    WSCallUserAnnualIncomeValue: string;
    WSCallUserPanNumber: string;
    WSCallUserEmailId: string;
    WSCallUserMobileNumber: string;
    WSCallCardType: string;
    WSCallCardCategory: string;
    WSCallGemId1: string;
    WSCallGemId2: string;
    WSCallDomainName: string;
    WSCallIpaddress: string;
    WSCallHostname: string;
    WSCallUserSalutation: string;
    WSCallUserConsent: string;
    WSCallUserDesignation: string;
    WSCallUserCompany: string;
    WSCallUserOfficePincode: string;
    WSCallUserHouseNo: string;
    WSCallUserLocality: string;
    WSCallUserAddressLine: string;
    WSCallUserResiPincode: string;
    WSCallUserNationality: string;
    WSCallUserCouponCode: string;
    WSCallSourceCode: string;
    WSCallChannelCode: string;
    WSCallUpdateIncompleteAppFlag: string;
    WSCallPromoCode: string;
    WSCallUserContactConsent:string;
    WSCallUserCibelOtherConsent: string;
    WSCallUserSbiRelationShipNumber: string;
    WSCallUserHousingLoan: string;
    WSCallUserCarLoan: string;
    WSCallUserSavingsAccount: string;
    WSCallAppSourceCode: string;
    WSCallApplicationSource: string;
    WSCallCardReferralCode: string;
    WSCallLeadOrigination:string;

}